<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 업무 -->
          <c-select
            :comboItems="comboTaskItems"
            itemText="codeName"
            itemValue="code"
            type="search"
            name="taskClassName"
            label="LBLWORK"
            v-model="searchParam.taskClassName"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <!-- 변경/추가 내역 목록 -->
    <c-table
      ref="table"
      title="LBL0001157"
      :merge="grid.merge"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      selection="multiple"
      rowKey="taskId"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
          <c-btn v-if="editable" label="LBLSELECT" icon="check" @btnClicked="select" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'riskOccasion',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
        }
      },
    }
  },
  data() {
    return {
      grid: {
        merge: [
          { index: 0, colName: 'taskClassName' }
        ],
        columns: [
          {
            name: 'taskClassName',
            field: 'taskClassName',
            label: 'LBLWORK',
            align: 'center',
            style: 'width:30%',
            sortable: false,
          },
          {
            name: 'taskTitle',
            field: 'taskTitle',
            label: 'LBLTITLE',
            align: 'left',
            style: 'width:70%',
            sortable: false,
          },
        ],
        data: [],
        height: '650px'
      },
      searchParam: {
        taskClassName: null,
      },
      comboTaskItems: [
        { code: '설비', codeName: '설비' },
        { code: '기계기구', codeName: '기계기구' },
        { code: '공정', codeName: '공정' },
        { code: '화학자재', codeName: '화학자재' },
        { code: '사고', codeName: '사고' },
      ],
      editable: true,
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.assessOccasion.task.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    select() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다. 
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
  }
};
</script>
